import FormHandler from '../../forms/FormHandler';
import { Country, State } from '../../forms/address/types';
import StateFilteredAddress from '../../forms/address/StateFilteredAddress';

interface PageConfig {
  stateFilterData: { states: State[]; countries: Country[]; };
}

window.tnew.page.initialize = ({ stateFilterData }: PageConfig) => {
  const $form = document.querySelector('#tn-contribution-form') as HTMLFormElement;

  const formHandler = new FormHandler($form);

  StateFilteredAddress.createForCustomFormFields($form, formHandler, stateFilterData);
};
